import {
  EnumEntityReferenceType,
  EnumOwnerType,
  PersonDetailsQuery,
  usePersonNextOrderQuery,
} from "gql/generated";
import { useLoggedInAs } from "shared/hooks";

export type UseNextBookingProps = {
  person: PersonDetailsQuery["personDetails"];
};

export const useNextBooking = ({ person }: UseNextBookingProps) => {
  const loggedInAs = useLoggedInAs();
  const storefrontId = loggedInAs?.entityId;

  const { data } = usePersonNextOrderQuery({
    variables: {
      personId: person?._id ?? "",
      ...(loggedInAs &&
        loggedInAs.type === EnumOwnerType.Storefront && {
          entityId: storefrontId,
          type: EnumEntityReferenceType.Storefront,
        }),
    },
  });

  return {
    nextOrder: data?.personNextOrder,
  };
};
